import {
    IDefaultTableColumnConfig,
    IDigAdSummaryConfig,
    IDualAxisLineGraphConfig,
    ICardHeaderConfig,
    INameValuePair} from '../../../../_shared/models/models-index';

export class DigAdSummaryConfig implements IDigAdSummaryConfig {
    public benchmarkCardHeader: ICardHeaderConfig = null;
    public graphConfig: IDualAxisLineGraphConfig = null;
    public trendTableMetrics: INameValuePair[] = [];
    public summaryTableColumns: IDefaultTableColumnConfig[] = [];
}
